import React, {useEffect} from "react";
import {useThree} from "@react-three/fiber";
import {MainScene} from "./MainScene";

export const WriteMainScene: React.FunctionComponent = () => {
    const { scene, camera, gl, controls } = useThree();

    useEffect(() => {
        MainScene.scene = scene
        MainScene.camera = camera
        MainScene.renderer = gl
        MainScene.controls = controls
    }, [scene, camera, gl, controls])

    return null;
};
